/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Grower_Camera_ConfigInputs */

const vi_error_grower_camera_config = /** @type {(inputs: Error_Grower_Camera_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera vùng trồng chưa được cấu hình đúng với SmartLab. Đã báo quản trị.`)
};

/**

* @param {Error_Grower_Camera_ConfigInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_grower_camera_config = /** @type {((inputs?: Error_Grower_Camera_ConfigInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Grower_Camera_ConfigInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_grower_camera_config(inputs)
});